import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { Subscription } from "rxjs";
import { PhoneNumberInputComponent } from "../../components/phoneNumberInput/phoneNumberInput.component";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";

interface ChangePhoneNumberDialogModalData {
  title: string | (() => string);
  description: string | (() => string);
  buttonTextAccept: string | (() => string);
  buttonTextDeny: string | (() => string);
}

@Component({
  selector: "changePhoneNumberDialog",
  templateUrl: "./changePhoneNumberDialog.component.html",
  styleUrls: ["./changePhoneNumberDialog.component.scss"]
})

export class ChangePhoneNumberDialogComponent implements OnInit {
  @ViewChild("phoneNumberInput") phoneNumberInput: PhoneNumberInputComponent;
  private _localeChangeSubscription: Subscription;

  constructor(public bottomSheetRef: MatBottomSheetRef<ChangePhoneNumberDialogComponent, string>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public dialogData: ChangePhoneNumberDialogModalData
    , private _coreLanguageService: CoreLanguageService
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
  ) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("ChangePhoneNumberDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    this._localeChangeSubscription = this._internationalisationService.localeChanged.subscribe(() => {
      this.PushChanges();
    });
  }

  public evaluateLanguageString(value: string | (() => string) | boolean): string {
    const me = this;
    if (typeof value === "string") {
      if (value.startsWith("ph")) {
        return me._coreLanguageService.value(value);
      } else {
        return value;
      }
    } else if (typeof value === "function") {
      return value();
    }
  }

  public changePhoneNumber() {
    const me = this;
    let newPhoneNumber: string = me.phoneNumberInput.PhoneNumber;
    me.bottomSheetRef.dismiss(newPhoneNumber);
  }

  public cancelBtn() {
    const me = this;
    me.bottomSheetRef.dismiss("");
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._localeChangeSubscription) {
      me._localeChangeSubscription.unsubscribe();
    }
  }
}
